import React, { useEffect, useRef, useState } from 'react';
import '../../views/styles.css';
import 'bootstrap/dist/css/bootstrap.css';
import './modal.css';
import ReactDragListView from 'react-drag-listview';
import 'font-awesome/css/font-awesome.min.css';
import FadeIn from 'react-fade-in';
import CreatableSelect from 'react-select/creatable';
import { getAllUsers } from '../../api/UsersApi';
import { getPersons } from '../../api/AccountsApi';
import { getPiplines, getStages } from '../../api/SettingsApi';
import { createDealApi, putDealApi } from '../../api/SalesApi';
import { toast } from 'react-toastify';
import { getTasks } from 'api/SalesApi';
import { useHistory } from 'react-router-dom';
import moment from "moment";

const createOption = (label) => ({
    label,
    value: label.toLowerCase().replace(/\W/g, ''),
});
function DealModal({
    handleClose,
    isDealEdit,
    currentSelectedDeal,
    setRefreshDeals,
}) {
    const [isLoading, setIsLoading] = useState(false);
    const [change, setChange] = useState(false);
    const [pipline, setPipline] = useState([]);
    const [stage, setStage] = useState([]);
    const [selectedPipline, setSelPipline] = useState(-1);
    const [selectedStage, setSelStage] = useState(null);
    const [assignee, setAssignee] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [contactsOptions, setContactsOptions] = useState([]);
    const [hasTasks, setHasTasks] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [task, setTask] = useState(null);

    const history = useHistory();
    //Ref for form fields
    const DealNameRef = useRef(null);
    const DealPipelineRef = useRef(null);
    const DealStageRef = useRef(null);
    const DealAmountRef = useRef(null);
    const DealCloseDateRef = useRef(null);
    const DealAssigneeRef = useRef(null);
    const DealContactRef = useRef(null);
    const DealNoteRef = useRef(null);

    useEffect(() => {
        getAllUsers(1000, 0).then((users) => {
            setAssignee(users);
            if (isDealEdit) {
                DealAssigneeRef.current.value = currentSelectedDeal.assignee.id;
            }
        });
        getPersons(50, 0, '').then((users) => {
            users = users.map((u) => {
                return { label: u.firstName + ' ' + u.lastName + ` ${u.email}`, value: u.id };
            });
            setContactsOptions(users);
        });
        getPiplines(1000, 0).then((pips) => {
            setPipline(pips);
            let pip = pips[0].id;
            setSelPipline(pip);
            if (isDealEdit) {
                DealPipelineRef.current.value = currentSelectedDeal.stage.pipeline;
            }
            getStages(pip, 1000, 0).then((s) => {
                setStage(s);
                setSelStage(s[0].id);
                if (isDealEdit) {
                    DealStageRef.current.value = currentSelectedDeal.stage.id;
                }
            });
        });
    }, []);

    useEffect(() => {
        if (selectedPipline !== '-1') {
            getStages(selectedPipline, 1000, 0).then((s) => {
                setStage(s);
                setSelStage(s[0].id);
                if (isDealEdit) {
                    DealStageRef.current.value = currentSelectedDeal.stage.id;
                }
            });
        }
    }, [selectedPipline]);

    useEffect(() => {

        setRefreshDeals(false);
        if (isDealEdit) {
            DealNameRef.current.value = currentSelectedDeal.name.value;
            DealAmountRef.current.value = currentSelectedDeal.amount.value;
            DealCloseDateRef.current.value = moment(currentSelectedDeal.closeDate.value).format("YYYY-MM-DD");
            DealNoteRef.current.value = currentSelectedDeal.text.value;
            setIsLoading(true)
            let contactarr = []
            currentSelectedDeal.persons.forEach(obj => {
                let contact = {
                    label: (obj.firstName + " " + obj.lastName) + " " + `(${obj.email})`,
                    value: obj.id
                }
                contactarr.push(contact)
            })
            setContacts(contactarr);
        }
    }, [isDealEdit, currentSelectedDeal]);
    const customStyles = {
        valueContainer: (provided, state) => ({
            ...provided,
            outline: 'none',
            outline: 'none',
            paddingTop: 0,
            marginTop: 0,
            paddingBottom: '12px',
        }),
        placeholder: (provided, state) => ({
            ...provided,
            outline: 'none',
        }),
        control: (base) => ({
            ...base,
            border: '1px solid rgb(118, 118, 118)',
            boxShadow: 'none',
            paddingTop: '2px',
        }),
    };

    const inputChangeTasks = (inputValue, actionMeta) => {
        getTasks({
            search: inputValue,
        }).then((data) => {
            data = data.map((u) => {
                return { label: u.title, value: u.id };
            });
            setTasks(data);

        });
    };

    const handleInputChange = (inputValue, actionMeta) => {

        if (inputValue) {
            getPersons(1000, 0, inputValue).then((users) => {
                users = users.map((u) => {
                    return { label: u.firstName + ' ' + u.lastName + ` ${u.email}`, value: u.id };
                });
                setContactsOptions(users);
            });
        }
    };
    const handleChange = (newValue, actionMeta) => {
        setChange(true);
        setContacts(newValue);
    };
    const handleCreate = (inputValue) => {
        setChange(true);
        setIsLoading(true);
        setTimeout(() => {
            const newOption = createOption(inputValue);
            setContacts([...contacts, newOption]);
            setIsLoading(false);
        }, 1000);
    };

    const handleChangePip = (e) => {
        setSelPipline(e.target.value);
    };
    const createDeal = () => {
        let obj = {
            name: {
                value: DealNameRef.current.value,
            },
            closeDate: {
                value: DealCloseDateRef.current.value || null,
            },
            amount: {
                value: DealAmountRef.current.value || 0,
            },
            text: {
                value: DealNoteRef.current.value,
            },
            stage: selectedStage,
            assignee: DealAssigneeRef.current.value,
            persons: contacts.map((c) => c.value),
        };
        createDealApi(obj).then(() => {
            toast.success('Deal has been created successfully');
            setRefreshDeals(true);
            handleClose(true);
        }).catch(err => {
            toast.error("Something went wrong on the server side")
        });
    };

    const editDeal = () => {
        history.push(`/admin/sales/dealDetail`, { dealId: currentSelectedDeal.id })
    };
    return (
        <>
            <div
                className='modal fadeIn'
                style={{
                    display: 'block',
                    zIndex: 9999,
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0,0,0,0.3)',
                }}
                role='dialog'
                id='kwModal'
            >
                {/* modal start */}
                <FadeIn>
                    <form>
                        <div
                            className='modal-dialog modal-dialog-centered kw-workflow-modal'
                            role='document'
                            style={{ justifyContent: 'center', paddingTop: '2%' }}
                        >
                            <div
                                className='cmodal modal-content'
                                style={{
                                    maxWidth: '600px',
                                    minHeight: '100px',
                                    borderRadius: '12px',
                                    borderWidth: 0,
                                }}
                            >
                                <div className='m-header' style={{ marginBottom: '10px' }}>
                                    <span>{DealNameRef.current ? DealNameRef.current.value : 'Create Deal' }</span>
                                    <span style={{ cursor: 'pointer' }} onClick={handleClose}>
                                        x
                                    </span>
                                </div>
                                <div className='m-grid-cont'>
                                    <div
                                        className='m-attr'
                                        style={{ gridColumnStart: 1, gridColumnEnd: 3 }}
                                    >
                                        <h6>Name</h6>
                                        <input
                                            required
                                            style={{ height: '45px' }}
                                            id='name'
                                            placeholder='Type Name'
                                            ref={DealNameRef}
                                            disabled={isDealEdit}
                                        ></input>
                                    </div>
                                    <div
                                        className='m-attr'
                                        style={{ gridColumnStart: 1, gridColumnEnd: 1 }}
                                    >
                                        <h6>Pipline</h6>
                                        <select
                                            // disabled
                                            ref={DealPipelineRef}
                                            onChange={handleChangePip}
                                            value={selectedPipline}
                                            disabled={isDealEdit}
                                        >
                                            <option value='-1'>select</option>

                                            {pipline &&
                                                pipline.map((p) => {
                                                    return <option value={p.id}>{p.name}</option>;
                                                })}
                                        </select>
                                    </div>

                                    <div
                                        className='m-attr'
                                        style={{ gridColumnStart: 2, gridColumnEnd: 2 }}
                                    >
                                        <h6>Stage</h6>
                                        <select
                                            required
                                            ref={DealStageRef}
                                            value={selectedStage}
                                            onChange={(e) => setSelStage(e.target.value)}
                                            disabled={isDealEdit}
                                        >
                                            {stage &&
                                                stage.map((p) => {
                                                    return <option value={p.id}>{p.label}</option>;
                                                })}
                                        </select>
                                    </div>
                                    <div
                                        className='m-attr'
                                        style={{ gridColumnStart: 1, gridColumnEnd: 1 }}
                                    >
                                        <h6>Amount</h6>
                                        <div>
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    left: '40px',
                                                    paddingTop: '12px',
                                                }}
                                            >
                                                $
                                            </span>
                                            <input
                                                required
                                                style={{ height: '45px', paddingLeft: '30px' }}
                                                id='amount'
                                                ref={DealAmountRef}
                                                disabled={isDealEdit}
                                            ></input>
                                        </div>
                                    </div>

                                    <div
                                        className='m-attr'
                                        style={{ gridColumnStart: 2, gridColumnEnd: 2 }}
                                    >
                                        <h6>Close Date</h6>
                                        <input
                                            required
                                            style={{ height: '45px' }}
                                            id='date'
                                            type='date'
                                            ref={DealCloseDateRef}
                                            disabled={isDealEdit}
                                        ></input>
                                    </div>
                                    <div
                                        className='m-attr'
                                        style={{ gridColumnStart: 1, gridColumnEnd: 1 }}
                                    >
                                        <h6>Assignee</h6>
                                        <select required id='assignee' ref={DealAssigneeRef} disabled={isDealEdit}>
                                            {assignee &&
                                                assignee.map((user) => {
                                                    return <option value={user.id}>{user.name}</option>;
                                                })}
                                        </select>
                                    </div>

                                    <div
                                        className='m-attr'
                                        style={{ gridColumnStart: 2, gridColumnEnd: 2 }}
                                    >
                                        <div style={{ display: 'flex' }}>
                                            <h6 onClick={(e) => setHasTasks(false)}>Contacts</h6>
                                        </div>

                                        <CreatableSelect
                                            isMulti={true}
                                            isClearable
                                            formatCreateLabel={() => undefined}
                                            
                                            // onChange={handleChangeTags}
                                            onInputChange={handleInputChange}
                                            value={contacts}
                                            placeholder={''}
                                            onChange={handleChange}
                                            onCreateOption={handleCreate}
                                            isDisabled={isLoading}
                                            isLoading={isLoading}
                                            styles={customStyles}
                                            options={contactsOptions}
                                        />
                                    </div>
                                    <div
                                        className='m-attr'
                                        style={{ gridColumnStart: 1, gridColumnEnd: 3 }}
                                    >
                                        <h6>Notes</h6>
                                        <textarea
                                            style={{ padding: '7px' }}
                                            id='notes'
                                            placeholder='Type a note'
                                            ref={DealNoteRef}
                                            disabled={isDealEdit}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className='m-footer' style={{ paddingTop: '10px' }}>
                                    <input
                                        type='button'
                                        name='Create'
                                        style={{ margin_top: '2v', cursor: 'pointer' }}
                                        className='add lg_btn primary'
                                        value={isDealEdit ? 'Edit' : 'Create'}
                                        onClick={() => {
                                            if (isDealEdit) {
                                                editDeal();
                                            } else {
                                                createDeal();
                                            }
                                        }}
                                    />
                                    <span className='ml-5'></span>
                                    <input
                                        type='button'
                                        name='Cancel'
                                        style={{
                                            margin_top: '2v',
                                            cursor: 'pointer',
                                            marginLeft: '22px',
                                        }}
                                        className='ml-22 add lg_btn tertiary'
                                        value='Cancel'
                                        onClick={handleClose}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </FadeIn>
            </div>
        </>
    );
}
export default DealModal;
